





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { AufgabeStatusDruck, AufgabeStatusAbfrage } from "../ChartTypesAndFunctions";
import ChartBase from "./ChartBase";

@Component
export default class DashboardListe extends ChartBase {
  private showFilter: boolean = false;
  private showHeader: boolean = false;
  private showAvatarLeft: boolean = false;
  private showSpeedDial: boolean = false;
  private showAvatar: boolean = false;
  private drucke: AufgabeStatusDruck[] = [];
  private exporte: AufgabeStatusAbfrage[] = [];
  private showZuordnung: boolean = true;
  private initalized: boolean = false;
  @Prop({ default: false }) private persoenlich!: boolean;
  private formularUebergabe!: ALLFrame;

  private baseListVector: number[] = [];

  public mounted() {
    if (!this.params.aufgabenDefinition) {
      console.log("no query given for ui");
      return;
    }
    if (this.params?.aufgabe) {
      this.formularUebergabe = this.params.aufgabe;
    }
    this.drucke = this.zuordnungen
      ?.filter((z) => z.gruppe === "Druck")
      .map((z) => z as AufgabeStatusDruck);
    this.drucke.sort(this.dynamicSort("bezeichnung"));
    this.exporte = this.zuordnungen
      ?.filter((z) => z.gruppe === "Abfrage")
      .map((z) => z as AufgabeStatusAbfrage);
    this.showAvatar = this.getKZAufgabeDefiniton("showAvatar");
    this.showAvatarLeft = this.getKZAufgabeDefiniton("showAvatarLeft");
    this.showSpeedDial = this.getKZAufgabeDefiniton("showSpeedDial");
    this.showHeader = this.getKZAufgabeDefiniton<boolean>("showHeader");
    this.showFilter = this.getKZAufgabeDefiniton<boolean>("showFilter");
    const hideZuordnung = this.getKZAufgabeDefiniton<boolean>("hideZuordnung");
    this.showZuordnung = !hideZuordnung;
    if (this.showHeader) {
      this.$emit("hideDialogTitel");
    }
    this.initalized = true;
  }
  protected QvAICsChanged(): void {
    // nothing to do here
  }
  private get concatVector() {
    return this.vector.concat(this.baseListVector);
  }

  private setzeVectorBaseListe(vec: number[]) {
    this.baseListVector = vec;
  }
}
